/* eslint-disable no-nested-ternary */
import React from 'react';
import { BsCircleFill } from 'react-icons/bs';
import { FaCheck } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';
import * as S from './styles';

interface CustomStepProps {
  estagio: string;
  typeIcon?: 'checked' | 'unchecked';
  momento?: string;
}

const CustomStep: React.FC<CustomStepProps> = (props) => {
  const { estagio, momento, typeIcon } = props;

  return (
    <S.Container typeIcon={typeIcon}>
      <div className="icon">
        {typeIcon === 'checked' ? (
          <FaCheck size={24} color="#ffffff" />
        ) : typeIcon === 'unchecked' ? (
          <IoMdClose size={24} color="#ffffff" />
        ) : (
          <BsCircleFill size={14} color="#95989B" />
        )}
      </div>

      <div className="info">
        <p className="estagio">{estagio}</p>
        {momento && <p className="momento">{momento === ', às ' ? '' : momento}</p>}
      </div>
    </S.Container>
  );
};

export default CustomStep;
